import styled from 'styled-components';
import Parent from './style';

const Wrapper = styled(Parent.Wrapper)`
    border-top: 2px solid #000;
    border-bottom: 2px solid #000;
`;

const Styled = {
  Wrapper
};
export default Styled;
